import TypesenseInstantsearchAdapter from "typesense-instantsearch-adapter";
import { dictionaryConfig, searchConfig } from "./typesense-server-config";

export function typesenseAdapter(
  queryBy,
  inFix,
  token,
  serverType = "default",
  sortBy
) {
  // Select the server configuration based on the serverType
  let TYPESENSE_SERVER_CONFIG;

  if (serverType === "dictionary") {
    TYPESENSE_SERVER_CONFIG = dictionaryConfig;
  } else {
    TYPESENSE_SERVER_CONFIG = searchConfig;
  }

  // Build search params while omitting undefined sort_by so default ranking = relevance
  const additionalSearchParameters = {
    query_by: queryBy,
    infix: inFix,
    //exclude_fields: "summary_vec",
  };
  if (sortBy) {
    additionalSearchParameters.sort_by = sortBy;
  }

  const typesenseInstantsearchAdapter = new TypesenseInstantsearchAdapter({
    server: TYPESENSE_SERVER_CONFIG,
    additionalSearchParameters,
  });

  return typesenseInstantsearchAdapter;
}
